import { render, staticRenderFns } from "./KpiSettingStaffExercise.vue?vue&type=template&id=0a9fb225"
import script from "./KpiSettingStaffExercise.vue?vue&type=script&lang=js"
export * from "./KpiSettingStaffExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports